"use client";

import Link from "./CustomLink";
import { Fragment, useCallback, useState } from "react";
import { type MenuFields_Fields } from "~/__generated__/graphql";
import { cn } from "~/utils/cn";
import toggleBodyScrolling from "~/utils/toggleBodyScrolling";

export default function HamburgerMenu({
  menuLinks,
}: {
  menuLinks: MenuFields_Fields["menuLinks"];
}) {
  const [open, setOpen] = useState(false);

  const onToggle = useCallback(() => {
    setOpen((prev) => {
      toggleBodyScrolling(!prev);
      return !prev;
    });
  }, []);

  return (
    <div className="flex h-full items-center hover:cursor-pointer lg:hidden">
      <span
        onClick={() => onToggle()}
        className="material-icons-round select-none p-[0.3125rem] text-white"
      >
        {open ? "close" : "menu"}
      </span>

      <div
        className={cn(
          "absolute left-0 top-full h-screen max-h-[calc(100vh-100%)] w-full overflow-auto bg-black bg-opacity-80 px-[2.125rem] pb-24 backdrop-blur-lg transition-opacity ease-in-out",
          open ? "visible opacity-100" : "invisible opacity-0",
        )}
      >
        <div className="flex flex-col">
          {menuLinks?.map((menuLink, i) => (
            <Fragment key={menuLink?.title}>
              <Link
                key={menuLink?.title ?? i}
                to={menuLink?.link?.url ?? ""}
                aria-label={menuLink?.title ?? "link"}
                onClick={() => onToggle()}
                className="flex h-20 items-center text-2xl tracking-wide text-white"
              >
                {menuLink?.title}
              </Link>
              {menuLink?.subMenuLinks && menuLink?.subMenuLinks?.length > 0 && (
                <div className="flex flex-col justify-center gap-1 px-2 py-1.5">
                  {menuLink?.subMenuLinks?.map((subMenuLink, j) => (
                    <Link
                      key={subMenuLink?.title ?? j}
                      to={subMenuLink?.link?.url ?? ""}
                      aria-label={subMenuLink?.title ?? "link"}
                      onClick={() => onToggle()}
                      className="flex h-11 items-center px-2 py-1.5 text-base tracking-wide text-white hover:border-l-4 hover:border-blue hover:pl-1 hover:font-bold hover:text-blue"
                    >
                      {subMenuLink?.title}
                    </Link>
                  ))}
                </div>
              )}
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
